import React from 'react';

import AppErrors from '../../components/AppErrors/AppErrors';
import { Spark } from '../components/Spark/Spark';
import { SparkSessionProvider } from '../components/Spark/SparkSessionProvider';
import { SparkStatusProvider } from '../components/Spark/SparkStatusProvider';

export type SparkPageProps = {
  name?: string;
};

export const SparkPage = ({ name = 'SPARK_PAGE' }: SparkPageProps) => {
  return (
    <div data-test={name}>
      <AppErrors />
      <SparkStatusProvider>
        <SparkSessionProvider>
          <Spark name="SPARK" />
        </SparkSessionProvider>
      </SparkStatusProvider>
    </div>
  );
};
